import React from 'react';
import { connect } from 'react-redux';
import history from '../../history';
import { popupBot, messageAsanas } from '../../actions';
import axios from 'axios';
import zonaEspana from '../hupUtils/zonaEspana';
import drive from '../../Media/drive.png';
import calendar from '../../Media/calendar.png';
import slack from '../../Media/slack.png';
import trelloImg from '../../Media/trello.png';
import asana from '../../Media/asana.png';
import googleSheet from '../../Media/googleSheet.png';
import clickup from '../../Media/clickup.png';
import perfil from '../../Media/perfil.png';
import fondo from '../../Media/fondo.jpg';
import asanaH from '../../apis/asana';
import { dataBaseManager } from '../hupUtils/utils';
import { clientIdAsana, clientSecrectAsana, clientSlack } from '../../apis/stringConnection';
import { Image, Row, Col, Container, Button, Modal, Form, Figure } from 'react-bootstrap';

let timelenght = 20000;
let Trello = require("trello");
let trello = null;

///pantalla de  perfil del usuario
//limpiar variables
const nivel = [
    <option value='105'>Normal</option>,
    <option value='115'>Competitivo</option>,
    <option value='125'>Altamente Competitivo</option>
]
const Semana = [
    <option value='5'>Viernes</option>,
    <option value='6'>Sabado</option>,
    <option value='7'>Domingo</option>
]

const styleButtonProfile ={  background: 'rgb(0, 179, 255)', borderRadius: '10px', color: '#2f0756', backgroundColor: 'aquamarine', borderRadius: '10px'}
class Profile extends React.Component {

    state = {
        open: null, listaEmpresas: {},  openImagen: false, entro: false,
        nombreUsuario: null, cargo: null,
        area: null, lugar: null, telefono: null,  
        idCalendar: null,
        codigoUsSlack: null,   canalGestorSlack: null,
        canalEquipoSlack: null, canalReportesSlack: null, canalNotifiacionesSlack: null,
        codigoWSdrive: null,
        activo: false, listaCanales_Slack: null, usuarioTrello: null, trelloListaDashBoard: null, trelloLista: null, trelloDashboard: null, 
        nivelEquipo: null, diaSemana: null, liscalendars: null,
        trelloIn: '100%', slackIn: '100%', driveIn: '0%', calendarIn: '100%',
        trelloApi: null, tokenTrello: null, listaObjetivostoDO: null, listaOBjetivosDone: null, listaObjetivosTheEnd: null, imagenMostrar: null, imagenFondo: null, imagenPerfil: null,
        asana: null, projectsIdAsana: null, sectionsAsana: null, collAsanaProyects: null,  asanaIn: 1
    }

    componentDatabase(tipo, path, objectIn, mensaje, mensajeError) {
        let men = dataBaseManager(tipo, path, objectIn, mensaje, mensajeError);
        console.log(men);
        if (men && men.mensaje)
            this.props.popupBot({ mensaje: men.mensaje });
        return men;
    }
    componentWillMount() {
        if (!this.props.isSignedIn || !this.props.userDetail) {
            history.push('/dashboard');
            return;
        }
    }
    componentDidMount() {

        //se consulta todas las empresas

        if (!this.props.isSignedIn || !this.props.userDetail) {
            history.push('/dashboard');
            return;
        }

        const starCountRef = this.componentDatabase("get", `empresa`);
        starCountRef.on('value', (snapshot) => {
            this.setState({ listaEmpresas: snapshot.val() })
        });

        //herramientas usuario
        if (this.props.userDetail.usuario.asana)
            this.setState({ asanaIn: 0 });
        if (this.props.userDetail.usuario.trello)
            this.setState({ trelloIn: 0 });
        if (this.props.userDetail.usuario.calendar)
            this.setState({ calendarIn: 0 });
        if (this.props.userDetail.usuario.slack)
            this.setState({ slackIn: 0 });


        if (this.props.messageAsana === 'Slack') {
            this.setState({ open: 'slack' });
            this.renderCargar('slack');
        }
        else if (this.props.messageAsana === 'Asana') {

            this.setState({ open: 'asana' });
            this.renderCargar('asana');
        }
        this.props.messageAsanas();
    }

    renderOpcionesEmpresa() {

        const listaX = this.state.listaEmpresas;
        let lista = {};
        const opciones = Object.keys(listaX).map(function (key, index) {
            lista = { ...lista, key: key, text: listaX[key].industria, value: listaX[key].industria };
            return lista;
        });
        return opciones;
    }


    renderOpcionesZona() {

        const listaX = zonaEspana();
        let entro = null;
        Object.keys(listaX).map((key, index) => {
            if (listaX[key].name === ' ')
                entro = true;
            return listaX[key];

        });

        if (!entro) {
            listaX.unshift(' ');
        }

        let lista = {};
        const opciones = Object.keys(listaX).map(function (key, index) {
            lista = { ...lista, key: key, text: listaX[key], value: listaX[key] };
            return lista;
        });
        return opciones;


    }


    renderCalendars(listaX) {

        if (listaX) {
            const opciones = Object.keys(listaX).map((key, index) => {
                return <option value={listaX[key].id}>{listaX[key].summary}</option>
            });

            return opciones;
        }
        return null;
    }


    renderCanaleSlack() {

        let listaX = this.state.listaCanales_Slack;
        if (listaX) {
            const opciones = Object.keys(listaX).map((key, index) => {
                return <option value={listaX[key].id}>{listaX[key].name}</option>
            });
            return opciones;
        }
        return null;
    }


    renderValidateSlack() {

        if (this.state.canalEquipoSlack === undefined && this.state.canalReportesSlack === undefined && this.state.canalNotifiacionesSlack === undefined) {
            this.setState({ activo: true });
        }

        else {
            this.setState({ activo: false });
        }

    }
    renderUsuarioSlack() {

        let op = this.renderCanaleSlack();
        let formSlack = <Container className='fondo_form'>
            <Form>
                <Form.Group controlId="ControlSelect1">
                    <Form.Label>Cual es el canal mas importante?</Form.Label>
                    <Form.Control as="select"
                        value={this.state.canalReportesSlack}
                        onChange={(e) => { this.setState({ canalReportesSlack: e.target.value }); this.renderValidateSlack(); }}
                    >
                        {op}

                    </Form.Control>
                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="ControlSelect2">
                    <Form.Label>Cual sera el canal de tu equipo?</Form.Label>
                    <Form.Control as="select"
                        value={this.state.canalEquipoSlack}
                        onChange={(e) => { this.setState({ canalEquipoSlack: e.target.value }); this.renderValidateSlack(); }}
                    >
                        {op}

                    </Form.Control>
                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="ControlSelect3">
                    <Form.Label>Menciona otro canal importante?</Form.Label>
                    <Form.Control as="select"
                        value={this.state.canalNotifiacionesSlack}
                        onChange={(e) => { this.setState({ canalNotifiacionesSlack: e.target.value }); this.renderValidateSlack(); }}
                    >
                        {op}

                    </Form.Control>
                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                </Form.Group>
                <Row>
                    <Col md={{ span: 4, offset: 4 }} xs={{ span: 8, offset: 2 }} className='form_height'>
                        <Button style={styleButtonProfile} onClick={(e) => { this.renderGuardar() }} disabled={this.state.canalEquipoSlack ? false : true}>
                            Guardar  <i className="material-icons md-18">save</i>
                        </Button>
                    </Col>
                </Row>
            </Form>
        </Container>


        if (this.state.listaCanales_Slack === undefined || !this.state.listaCanales_Slack) {
            formSlack = <div>
                <Form  >
                    <Row>
                        <Col md={{ span: 4, offset: 4 }} xs={{ span: 8, offset: 2 }} className='form_height'>
                            <a href={`https://slack.com/oauth/authorize?scope=bot&redirect_uri=${window.location.origin}&client_id=${clientSlack}`}><Image src="https://api.slack.com/img/sign_in_with_slack.png" /></a>
                        </Col>
                    </Row>

                </Form>
                <br />
            </div>
        }

        return (
            formSlack
        );
    }


    renderForm() {
        if (this.state.open === 'slack')
            return (this.renderUsuarioSlack());
        else if (this.state.open === 'drive')
            return (this.renderDrive());
        else if (this.state.open === 'calendar')
            return (this.renderCalendar());
        else if (this.state.open === 'asana')
            return (this.renderAsana());
        else if (this.state.open === 'sheet')
            return (this.renderConstruccion());
        else if (this.state.open === 'clickup')
            return (this.renderConstruccion());
        else if (this.state.open === 'trello')
            return (this.renderTrello());
        else {
            return (this.renderUsuario());
        }
    }


    renderDrive() {
        return (<Container className='fondo_form'>
            <Form>
                <Form.Group controlId="ControlInput1">
                    <Form.Label>Codigo de tu espacio de trabajo (carpeta)</Form.Label>
                    <Form.Control name="codWorkSpace"
                        type="text" placeholder="1J45vud1Mkb6mxfWYrVjHki_AO21..." value={this.state.codigoWSdrive}
                        onChange={e => this.setState({ codigoWSdrive: e.target.value })}>
                    </Form.Control>
                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                </Form.Group>
            </Form>
            <Row>
                <Col md={{ span: 4, offset: 4 }} xs={{ span: 8, offset: 2 }} className='form_height'>
                    <Button style={styleButtonProfile} disabled={this.state.codigoWSdrive ? false : true} onClick={() => { this.renderGuardar() }} className="ui pink button inverted ">
                        Guardar  <i className="material-icons md-18">save</i>
                    </Button>
                </Col>
            </Row>
        </Container>
        );
    }



    renderCalendar() {

        if (!this.state.liscalendars) {
            window.gapi.client.load("https://content.googleapis.com/discovery/v1/apis/calendar/v3/rest")
                .then(() => {
                    console.log("GAPI client loaded for API");
                    window.gapi.client.calendar.calendarList.list().then((res) => { console.log(res.result.items); this.setState({ liscalendars: res.result.items }); })
                },
                    function (err) { console.error("Error loading GAPI client for API", err); });

        }
        /*
        //Crear un evento
                window.gapi.client.calendar.events.insert({
                    'calendarId': 'primary',
                    'resource': event
                })
                    .then(function (response) {
                        // Handle the results here (response.result has the parsed body).
                        console.log("Response", response);
                    },
                        function (err) { console.error("Execute error", err); });
        
        
        */

        /*
        Crear un calendario
        
                window.gapi.client.calendar.calendars.insert({
                    "resource": {
                        "summary": "hupity 2"
                    }
                })
                    .then(function (response) {
                        // Handle the results here (response.result has the parsed body).
                        console.log("Response", response);
                    },
                        function (err) { console.error("Execute error", err); });*/
        return (
            <Container className='fondo_form'>
                <Form>
                    <Form.Group controlId="ControlSelect4">
                        <Form.Label>Selecciona tu calendario de google</Form.Label>
                        <Form.Control as="select"
                            value={this.state.idCalendar}
                            onChange={(e) => { this.setState({ idCalendar: e.target.value }); }}
                        >
                            {this.renderCalendars(this.state.liscalendars)}
                        </Form.Control>
                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                    </Form.Group>
                </Form>
                <Row>
                    <Col md={{ span: 4, offset: 4 }} xs={{ span: 8, offset: 2 }} className='form_height'>
                        <Button style={{ background: '#00b3ff', borderRadius: '10px' }} disabled={this.state.idCalendar ? false : true} onClick={() => { this.renderGuardar() }} >
                            Guardar  <i className="material-icons md-18">save</i>
                        </Button>
                    </Col>
                </Row>
            </Container>
        );
    }

    renderOpcionesTrello(listaOpciones) {

        let listaX = listaOpciones;
        let entro = null;

        if (!listaX)
            return;

        Object.keys(listaX).map((key, index) => {
            if (listaX[key].name === 'Ninguno')
                entro = true;
            return listaX[key];
        });

        if (!entro) {
            listaX.unshift({ name: 'Ninguno', id: '' });
        }

        const opciones = Object.keys(listaX).map((key, index) => {
            return <option value={listaX[key].id}>{listaX[key].name}</option>
        });
        return opciones;

    }

    componentDidUpdate() {
        if (this.state.trelloApi && !this.state.tokenTrello) {

            const starCountRef2 = this.componentDatabase("get", `Usuario-TokenTrelloTemp/${this.props.userDetail.idUsuario}`);
            starCountRef2.on('value', (snapshot2) => {

                if (snapshot2.val()) {

                    this.setState({ tokenTrello: snapshot2.val().token });
                    trello = new Trello(this.state.trelloApi, snapshot2.val().token);
                    trello.makeRequest('get', '/1/members/me/tokens', { webhooks: true }).then((res) => {
                        //    console.log(res[0].idMember)
                        this.setState({ usuarioTrello: res[0].idMember });
                        trello.getBoards(res[0].idMember).then((Response) => { this.setState({ trelloListaDashBoard: Response }) })

                        this.componentDatabase("insert", `Usuario-Trello/${this.props.userDetail.idUsuario}`,
                            {
                                usuarioTrello: res[0].idMember,
                                trelloApi: this.state.trelloApi,
                                tokenTrello: snapshot2.val().token
                            }
                        );

                        this.renderCloseTrello();

                        this.myWindow.close();
                    });
                }


            });
        }
    }
    renderConsultaApiKeyTrello(valor) {
        this.renderClose()
        this.myWindow = window.open(`https://trello.com/1/authorize?expiration=never&scope=read,write,account&response_type=token&name=Server%20Token&key=${valor}&return_url=${window.location.origin}`, '', 'width=650,height=650,left=200,top=200');
    }

    renderFiltroTrello(valor) {
        if (valor !== '') {
            trello.getListsOnBoard(valor).then((Response) => { this.setState({ trelloLista: Response }); });
        }

    }


    renderCloseTrello(myWindow) {
        this.timeout = setTimeout(() => {
            this.componentDatabase("insert", `Usuario-TokenTrelloTemp/${this.props.userDetail.idUsuario}`, {});
        }, timelenght)
    }

    renderClose() {
        this.timeout = setTimeout(() => {
            this.myWindow2.close();
        }, 2500)
    }

    recibir_Parametros(valor) {
        alert(valor)
    }


    renderTrello() {

        let contruir = <Container className='fondo_form'>
            <Form>
                <Form.Group controlId="ControlInput1">
                    <Form.Label>Trello Api Key</Form.Label>
                    <Form.Control name="trelloApi"
                        type="text" placeholder="bb3cab1a303c7bf996d5..." value={this.state.trelloApi}
                        onChange={e => { this.setState({ trelloApi: e.target.value }); this.renderConsultaApiKeyTrello(e.target.value); }}>
                    </Form.Control>
                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                </Form.Group>
            </Form>
            <Row>
                <Col md={{ span: 4, offset: 4 }} xs={{ span: 8, offset: 2 }} className='form_height'>
                    <Button style={styleButtonProfile} onClick={() => {
                        this.myWindow2 = window.open('https://trello.com/app-key/', '', 'width=650,height=650,left=200,top=200');
                        this.props.popupBot({ mensaje: "copia el valor de tu 'key' en la caja de texto" });
                    }}>
                        Generar  <i className="material-icons md-18">wifi_protected_setup</i>
                    </Button>
                </Col>
            </Row>
        </Container>


        if (this.state.trelloApi && this.state.tokenTrello) {
            contruir = <Container className='fondo_form'>
                <Form>
                    <Form.Group controlId="ControlSelect5">
                        <Form.Label>Selecciona Dashboard</Form.Label>
                        <Form.Control as="select"
                            value={this.state.trelloDashboard}
                            onChange={(e) => { this.setState({ trelloDashboard: e.target.value }); this.renderFiltroTrello(e.target.value); }}
                        >
                            {this.renderOpcionesTrello(this.state.trelloListaDashBoard)}

                        </Form.Control>
                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="ControlSelect6">
                        <Form.Label>Lista Objetivos por trabajar</Form.Label>
                        <Form.Control as="select"
                            value={this.state.listaObjetivostoDO}
                            onChange={(e) => { this.setState({ listaObjetivostoDO: e.target.value }); }}
                        >
                            {this.renderOpcionesTrello(this.state.trelloLista)}

                        </Form.Control>
                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="ControlSelect7">
                        <Form.Label>Lista Objetivos terminados</Form.Label>
                        <Form.Control as="select"
                            value={this.state.listaOBjetivosDone}
                            onChange={(e) => { this.setState({ listaOBjetivosDone: e.target.value }); }}
                        >
                            {this.renderOpcionesTrello(this.state.trelloLista)}

                        </Form.Control>
                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                    </Form.Group>
                </Form>
                <Row>
                    <Col md={{ span: 4, offset: 4 }} xs={{ span: 8, offset: 2 }} className='form_height'>
                        <Button style={styleButtonProfile} disabled={this.state.trelloDashboard && ((this.state.listaObjetivostoDO && this.state.listaObjetivostoDO !== '') ||
                            (this.state.listaOBjetivosDone && this.state.listaOBjetivosDone !== '') ||
                            (this.state.listaObjetivosTheEnd && this.state.listaObjetivosTheEnd !== '')) ? false : true} onClick={() => {
                                this.componentDatabase("delete", `Usuario-TokenTrelloTemp/${this.props.userDetail.idUsuario}`);
                                this.renderGuardar()
                            }}>
                            Guardar  <i className="material-icons md-18">wifi_protected_setup</i>
                        </Button>
                    </Col>
                </Row>
            </Container>
        }

        // 
        return (
            <div>
                {contruir}
            </div>

        );
    }

    renderConsultasAsana = (consulta, value) => {
        let response = null

        switch (consulta) {
            case 'projects':
                response = asanaH.get('/api/1.0/projects', { headers: { Authorization: 'Bearer ' + this.state.asana.token } }).then((res) => { this.setState({ collAsanaProyects: res.data.data }); }).catch(err => { this.setState({ asana: null }) });
                break;

            case 'sections':
                console.log(value.value)
                response = asanaH.get('/api/1.0/projects/' + value.value + '/sections', { headers: { Authorization: 'Bearer ' + this.state.asana.token } }).then((res) => this.setState({ collsectionsAsana: res.data.data }));
                break;
            default:
                break
        }

        return response;
    }


    renderOpcionesAsana(listaOpciones) {

        let listaX = listaOpciones;
        if (!listaX)
            return;
        const opciones = Object.keys(listaX).map(function (key, index) {
            return <option value={listaX[key].id}>{listaX[key].name}</option>
        });
        return opciones;

    }

    renderAsana() {

        let formAsana = <Row>
            <Col xs={{ span: 11, offset: 1 }}>
                <Button style={{...styleButtonProfile, height: '3.5em' }}>
                    <Figure>
                        <Figure.Image
                            roundedCircle
                            width={40}
                            height={40}
                            alt="profile hupper"
                            src={asana}
                        />
                        {' '}
                        <a href={`https://app.asana.com/-/oauth_authorize?client_id=${clientIdAsana}&redirect_uri=${window.location.origin}&response_type=code&state=asana_0.8wpnz8r4jj8kaspekwp`}>Authenticate with Asana</a>

                    </Figure>

                </Button>
            </Col>
        </Row>



        if (this.state.asana) {
            formAsana = <Container className='fondo_form'>
                <Form>
                    <Form.Group controlId="ControlSelect8">
                        <Form.Label>Lista de tus proyectos</Form.Label>
                        <Form.Control as="select"
                            value={this.state.projectsIdAsana}
                            onChange={(e) => { this.setState({ projectsIdAsana: e.target.value }); if (e.target.value !== null) this.renderConsultasAsana('sections', e); }}
                        >
                            {this.renderOpcionesAsana(this.state.collAsanaProyects)}

                        </Form.Control>
                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="ControlSelect9">
                        <Form.Label>Lista de tus secciones</Form.Label>
                        <Form.Control as="select"
                            value={this.state.sectionsAsana}
                            onChange={(e) => { this.setState({ sectionsAsana: e.target.value }); }}
                        >
                            {this.renderOpcionesAsana(this.state.collAsanaProyects)}

                        </Form.Control>
                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                    </Form.Group>

                </Form>
                <Row>
                    <Col md={{ span: 4, offset: 4 }} xs={{ span: 8, offset: 2 }} className='form_height'>
                        <Button style={styleButtonProfile} disabled={this.state.sectionsAsana && this.state.projectsIdAsana ? false : true}
                            onClick={() => { this.renderGuardar(); this.setState({ asanaIn: 0 }); }}
                        >
                            Guardar  <i className="material-icons md-18">wifi_protected_setup</i>
                        </Button>
                    </Col>
                </Row>
            </Container>

        }

        return (
            <div>
                {formAsana}
            </div>

        );

    }

    renderConstruccion() {
        return (
            <Container fluid className="centerIntroOKR">
                <Row>
                    <Col md={{ span: 8, offset: 3 }} xs={{ span: 10, offset: 1 }} >
                        <div className="box" >
                            <h4>Lo estamos diseñando para ti...</h4>
                            <div className="loader9"></div>
                            <br></br>
                        </div >

                    </Col>
                </Row>
            </Container>

        );
    }

    renderUsuario() {
        let nnivel = null;
        if (this.props.userDetail.rol === '2') {
            nnivel = <Form.Group controlId="ControlSelect8">
                <Form.Label>Define el nivel de competitividad de tu equipo</Form.Label>
                <Form.Control as="select"
                    value={this.state.nivelEquipo ? this.state.nivelEquipo.nivel : 105}
                    onChange={(e) => { this.setState({ nivelEquipo: e.target.value }); }}
                >
                    {nivel}
                </Form.Control>
                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            </Form.Group>
        }

        return (

            <Container className='fondo_form'>
                <Form>
                    <Form.Group controlId="ControlInput3">
                        <Form.Label>Nombre Usuario</Form.Label>
                        <Form.Control name="nameUser"
                            type="text" placeholder="Cual es tu nombre?" value={this.state.nombreUsuario}
                            onChange={e => this.setState({ nombreUsuario: e.target.value })}>
                        </Form.Control>
                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="ControlInput4">
                        <Form.Label>Cargo</Form.Label>
                        <Form.Control name="cargo"
                            type="text" placeholder="Que cargo tienes?" value={this.state.cargo}
                            onChange={e => this.setState({ cargo: e.target.value })}>
                        </Form.Control>
                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="ControlInput5">
                        <Form.Label>Area</Form.Label>
                        <Form.Control name="area"
                            type="text" placeholder="¿En qué departamento de la empresa laboras?" value={this.state.area}
                            onChange={e => this.setState({ area: e.target.value })}>
                        </Form.Control>
                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                    </Form.Group>
                    {nnivel}
                    <Form.Group controlId="ControlSelect10">
                        <Form.Label>En que dia termina tu semana</Form.Label>
                        <Form.Control as="select"
                            value={this.state.diaSemana}
                            onChange={(e) => { this.setState({ diaSemana: e.target.value }); }}
                        >
                            {Semana}

                        </Form.Control>
                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="ControlInput2">
                        <Form.Label>Teléfono</Form.Label>
                        <Form.Control name="telefono"
                            type="text" placeholder="¿Dondé te podemos contactar?" value={this.state.telefono}
                            onChange={e => this.setState({ telefono: e.target.value })}>
                        </Form.Control>
                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                    </Form.Group>


                </Form>
                <Row>
                    <Col md={{ span: 4, offset: 5 }} xs={{ span: 6, offset: 3 }}>
                        <Button style={styleButtonProfile} disabled={this.state.activo}
                            onClick={() => { this.renderGuardar() }}>
                            Guardar  <i className="material-icons md-18">wifi_protected_setup</i>
                        </Button>
                    </Col>
                </Row>

            </Container>
        );
    }

    renderCargarImagen(imagen) {
        if (imagen)
            this.setState({ imagenMostrar: imagen })
        // https://react.semantic-ui.com/images/avatar/large/matthew.png
    }

    renderCambiarImagenPerfil() {
        if (this.props.userDetail.usuario.imagenFondo)
            this.setState({ imagenFondo: this.props.userDetail.usuario.imagenFondo })
        if (this.props.userDetail.usuario.imagenPerfil)
            this.setState({ imagenFondo: this.props.userDetail.usuario.imagenPerfil })
        this.setState({ openImagen: true })
    }

    close = () => this.setState({ openImagen: false })


    renderGuardar() {


        this.props.popupBot({ mensaje: 'Ya hemos guardado tu configuración' });

        if (this.state.open === 'slack') {
            this.setState({ slackIn: '0%' });
            if (!this.state.canalEquipoSlack || this.state.canalEquipoSlack === '')
                this.setState({ slackIn: '100%' });

            this.componentDatabase("update", `Usuario-Slack/${this.props.userDetail.idUsuario}`,
                {
                    gestor: this.state.canalGestorSlack,
                    notifiacaiones: this.state.canalNotifiacionesSlack,
                    reporting: this.state.canalReportesSlack,
                    equipo: this.state.canalEquipoSlack,
                });
            this.componentDatabase("update", `Usuario/${this.props.userDetail.idUsuario}`,
                {
                    slack: true,
                });


        }
        else if (this.state.open === 'drive') {
            this.setState({ driveIn: '0%' });
            if (!this.state.codigoWSdrive || this.state.codigoWSdrive === '')
                this.setState({ driveIn: '100%' });
            this.componentDatabase("insert", `Usuario-WS/${this.props.userDetail.usuario.empresa}/${this.props.userDetail.usuario.equipo}/${this.props.userDetail.idUsuario}`,
                {
                    linkWs: this.state.codigoWSdrive,
                    fechaCreado: new Date(),
                });
        }

        else if (this.state.open === 'calendar') {
            this.setState({ calendarIn: '0%' });
            if (!this.state.calendar || this.state.calendar === '')
                this.setState({ calendarIn: '100%' });

            this.componentDatabase("insert", `Usuario-CalendarGoogle/${this.props.userDetail.idUsuario}`,
                {
                    idCalendar: this.state.idCalendar,
                    fechaCreado: new Date(),
                });
            this.componentDatabase("update", `Usuario/${this.props.userDetail.idUsuario}`,
                {
                    calendar: true,
                });
        }
        else if (this.state.open === 'trello') {
            this.setState({ trelloIn: '0%' });
            if (!this.state.trelloApi || this.state.trelloApi === '' || !this.state.trelloDashboard || this.state.trelloDashboard === '' || !this.state.listaObjetivostoDO || this.state.listaObjetivostoDO === '')
                this.setState({ trelloIn: '100%' });

            this.componentDatabase("update", `Usuario-Trello/${this.props.userDetail.idUsuario}`,
                {
                    usuarioTrello: this.state.usuarioTrello,
                    trelloApi: this.state.trelloApi,
                    tokenTrello: this.state.tokenTrello,
                    trelloDashboard: this.state.trelloDashboard,
                    listaObjetivostoDO: this.state.listaObjetivostoDO ? this.state.listaObjetivostoDO : null,
                    listaOBjetivosDone: this.state.listaOBjetivosDone ? this.state.listaOBjetivosDone : null,
                    listaObjetivosTheEnd: this.state.listaObjetivosTheEnd ? this.state.listaObjetivosTheEnd : null,

                });
            this.componentDatabase("update", `Usuario/${this.props.userDetail.idUsuario}`,
                {
                    trello: true,
                });

        }

        else if (this.state.open === 'asana') {
            this.componentDatabase("update", `Usuario-Asana/${this.props.userDetail.idUsuario}`,
                {
                    project: this.state.projectsIdAsana,
                    section: this.state.sectionsAsana,
                });
            this.componentDatabase("update", `Usuario/${this.props.userDetail.idUsuario}`,
                {
                    asana: true,
                });

        }
        else {

            this.componentDatabase("update", `Usuario/${this.props.userDetail.idUsuario}`,
                {
                    ...this.props.userDetail.usuario,
                    usuario: this.state.nombreUsuario,
                    cargo: this.state.cargo,
                    area: this.state.area,
                    telefono: this.state.telefono,
                    lugar: this.state.lugar,
                    empresa: this.props.userDetail.usuario.empresa,
                    imagenFondo: this.state.imagenFondo,
                    imagenPerfil: this.state.imagenPerfil,
                    canalSlack: this.state.codigoUsSlack ? this.state.codigoUsSlack : this.props.userDetail.usuario.canalSlack ? this.props.userDetail.usuario.canalSlack : null,
                    equipo: this.props.userDetail.usuario.equipo,
                    onboarding: this.props.userDetail.usuario.onboarding ? this.props.userDetail.usuario.onboarding : null,
                    wsCompartida: this.state.codigoWSdrive ? this.state.codigoWSdrive : this.props.userDetail.usuario.wsCompartida ? this.props.userDetail.usuario.wsCompartida : null,
                    diaSemana: this.state.diaSemana ? this.state.diaSemana : 0,
                });

            if (this.props.userDetail.rol === '2')
                this.componentDatabase("insert", `Equipo-Esfuerzo/${this.props.userDetail.usuario.equipo}`,
                    {
                        ...this.state.nivelEquipo,
                        nivel: this.state.nivelEquipo.nivel,
                    });

        }

        //  this.setState({ activo: true });
    }



    renderCargar(pantalla) {
        this.setState({ activo: false });
        if (pantalla === 'slack') {
            const starCountRef = this.componentDatabase("get", `Usuario-Slack/${this.props.userDetail.idUsuario}`);
            starCountRef.on('value', (snapshot) => {
                if (snapshot.val()) {
                    this.setState({ canalGestorSlack: snapshot.val().gestor ? snapshot.val().gestor : null });
                    this.setState({ canalNotifiacionesSlack: snapshot.val().notifiacaiones ? snapshot.val().notifiacaiones : '' });
                    this.setState({ canalReportesSlack: snapshot.val().reporting ? snapshot.val().reporting : '' });
                    this.setState({ canalEquipoSlack: snapshot.val().equipo ? snapshot.val().equipo : '' });

                    axios.get(` https://slack.com/api/channels.list?token=${snapshot.val().tokenBot}&pretty=1`)
                        .then((res, tres) => {
                            // console.log(res.data);
                            this.setState({ listaCanales_Slack: res.data.channels });
                        });

                }

                if (!snapshot.val() || !snapshot.val().equipo)
                    this.setState({ slackIn: '100%' });
                else
                    this.setState({ slackIn: '0%' });



            });
        }
        else if (pantalla === 'drive') {
            const starCountRef = this.componentDatabase("get", `Usuario-WS/${this.props.userDetail.usuario.empresa}/${this.props.userDetail.usuario.equipo}/${this.props.userDetail.idUsuario}`);
            starCountRef.on('value', (snapshot) => {
                if (snapshot.val()) {
                    this.setState({ codigoWSdrive: snapshot.val().linkWs ? snapshot.val().linkWs : '' });
                }
                else {
                    this.setState({ codigoWSdrive: '' });
                }
                if (!snapshot.val() || !snapshot.val().linkWs)
                    this.setState({ driveIn: '100%' });
                else
                    this.setState({ driveIn: '0%' });
            });
        }

        else if (pantalla === 'calendar') {
            const starCountRef = this.componentDatabase("get", `Usuario-CalendarGoogle/${this.props.userDetail.idUsuario}`);
            starCountRef.on('value', (snapshot) => {
                if (snapshot.val()) {
                    this.setState({ idCalendar: snapshot.val().idCalendar ? snapshot.val().idCalendar : '' });
                }
                else {
                    this.setState({ idCalendar: '' });
                }
                if (!snapshot.val() || !snapshot.val().idCalendar)
                    this.setState({ calendarIn: '100%' });
                else
                    this.setState({ calendarIn: '0%' });

            });
        }

        else if (pantalla === 'asana') {

            const starCountRef = this.componentDatabase("get", `Usuario-Asana/${this.props.userDetail.idUsuario}`);
            starCountRef.on('value', (snapshot) => {
                if (snapshot.val()) {
                    this.setState({ asana: snapshot.val() });
                    this.setState({ projectsIdAsana: snapshot.val().project ? snapshot.val().project : null })
                    this.setState({ sectionsAsana: snapshot.val().section ? snapshot.val().section : null })
                    axios.post(`https://cors-anywhere.herokuapp.com/https://app.asana.com/-/oauth_token`, null, {
                        params: {
                            grant_type: 'refresh_token',
                            client_id: clientIdAsana, 'client_secret': clientSecrectAsana,
                            redirect_uri: window.location.origin, code: snapshot.val().code, 'refresh_token': snapshot.val().rToken
                        }
                    }).then(res => {
                        console.log(res);
                        this.setState({ asana: { ...this.state.asana, token: res.data.access_token } });
                        this.renderConsultasAsana('projects');
                    }
                    ).catch(err => { this.setState({ asana: null }); })

                }
                else {
                    this.setState({ asana: null });
                }

            });
        }
        else if (pantalla === 'trello') {
            const starCountRef = this.componentDatabase("get", `Usuario-Trello/${this.props.userDetail.idUsuario}`);
            starCountRef.on('value', (snapshot) => {
                if (snapshot.val()) {
                    this.setState({ trelloApi: snapshot.val().trelloApi ? snapshot.val().trelloApi : '' });
                    this.setState({ tokenTrello: snapshot.val().tokenTrello ? snapshot.val().tokenTrello : '' });
                    this.setState({ usuarioTrello: snapshot.val().usuarioTrello ? snapshot.val().usuarioTrello : '' });
                    this.setState({ trelloDashboard: snapshot.val().trelloDashboard ? snapshot.val().trelloDashboard : '' });
                    this.setState({ listaObjetivostoDO: snapshot.val().listaObjetivostoDO ? snapshot.val().listaObjetivostoDO : '' });
                    this.setState({ listaOBjetivosDone: snapshot.val().listaOBjetivosDone ? snapshot.val().listaOBjetivosDone : '' });
                    this.setState({ listaObjetivosTheEnd: snapshot.val().listaObjetivosTheEnd ? snapshot.val().listaObjetivosTheEnd : '' });
                    if (snapshot.val().trelloApi && snapshot.val().tokenTrello) {
                        trello = new Trello(snapshot.val().trelloApi, snapshot.val().tokenTrello);
                        trello.getBoards(snapshot.val().usuarioTrello).then((Response) => { this.setState({ trelloListaDashBoard: Response }) })
                        trello.getListsOnBoard(snapshot.val().trelloDashboard).then((Response) => { this.setState({ trelloLista: Response }); });
                    }
                }
                else {
                    this.setState({ trelloApi: '' });
                    this.setState({ tokenTrello: '' });
                    this.setState({ listaObjetivostoDO: '' });
                    this.setState({ listaOBjetivosDone: '' });
                    this.setState({ listaObjetivosTheEnd: '' });
                }
                if (!snapshot.val() || !snapshot.val().trelloApi || !snapshot.val().trelloDashboard || !snapshot.val().listaObjetivostoDO)
                    this.setState({ trelloIn: '100%' });
                else
                    this.setState({ trelloIn: '0%' });

            });

        }
        else {
            this.setState({ entro: true });
            this.setState({ nombreUsuario: this.props.userDetail.usuario.usuario });
            // this.setState({ empresa: this.props.userDetail.usuario.empresa });
            this.setState({ cargo: this.props.userDetail.usuario.cargo });
            this.setState({ diaSemana: this.props.userDetail.usuario.diaSemana ? this.props.userDetail.usuario.diaSemana : null });
            this.setState({ area: this.props.userDetail.usuario.area ? this.props.userDetail.usuario.area : '' });
            this.setState({ imagenFondo: this.props.userDetail.usuario.imagenFondo ? this.props.userDetail.usuario.imagenFondo : null });
            this.setState({ imagenPerfil: this.props.userDetail.usuario.imagenPerfil ? this.props.userDetail.usuario.imagenPerfil : null });
            this.setState({ telefono: this.props.userDetail.usuario.telefono ? this.props.userDetail.usuario.telefono : null });
            this.setState({ lugar: this.props.userDetail.usuario.lugar ? this.props.userDetail.usuario.lugar : null });

            const starCountRef = this.componentDatabase("get", `empresa/${this.props.userDetail.usuario.empresa}`);
            starCountRef.on('value', (snapshot) => {
                this.setState({ empresa: snapshot.val().industria })
            });

            if (this.props.userDetail.rol === '2') {
                const starCountRef2 = this.componentDatabase("get", `Equipo-Esfuerzo/${this.props.userDetail.usuario.equipo}`);
                starCountRef2.on('value', (snapshot) => {
                    if (snapshot.val())
                        this.setState({ nivelEquipo: snapshot.val() })
                });
            }
        }
    }


    render() {

        if (!this.props.userDetail)
            return <div></div>;

        if (this.props.userDetail && this.props.userDetail.usuario && !this.state.entro)
            this.renderCargar();
        



        return (
            <Container >
                <Row>
                    <Col md={11} xs={10}>
                        <Image className='image_fondo' src={this.state.imagenFondo ? this.state.imagenFondo : fondo} onClick={() => { this.setState({ open: null }); this.renderCambiarImagenPerfil(); }} />
                    </Col>
                    <Col md={1} xs={1}>
                        <Button className='change_image_fondo' style={{ background: '#240d40', borderRadius: '3em', width: '25px', height: '25px' }} onClick={() => { this.setState({ open: null }); this.renderCambiarImagenPerfil(); }}>
                            <i className="material-icons md-18">image</i>
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col md={{ span: 4 }} xs={{ span: 12 }} className='utils_image'>
                        <Row>
                            <Col md={{ span: 4 }} xs={7}>
                                <Image className='iamge_profile_src' alt='imagen perfil hupper' src={this.state.imagenPerfil ? this.state.imagenPerfil : perfil} onClick={() => { this.setState({ open: null }); this.renderCambiarImagenPerfil(); }} />
                            </Col>
                            <Col md={{ span: 3 }} xs={1}>
                                <Button className='change_image_fondo_profile' style={{ background: '#240d40', borderRadius: '3em', width: '25px', height: '25px' }} onClick={() => { this.setState({ open: null }); this.renderCambiarImagenPerfil(); }}>
                                    <i className="material-icons md-18">image</i>
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={{ span: 12 }} xs={{ span: 12 }} className='utils_image'>
                                <Row>
                                    <Col md={{ span: 1, offset: 1 }} xs={{ span: 1, offset: 1 }}>
                                        <Image alt='sincroniza slack' src={slack} onClick={() => { this.state.open === 'slack' ? this.setState({ open: null }) : this.setState({ open: 'slack' }); this.setState({ activo: false }); this.renderCargar('slack'); }}
                                            style={{ width: '4vh', borderRadius: '3em', filter: 'grayscale(' + this.state.slackIn + ')', background: this.state.open === 'slack' ? 'rgb(222, 181, 243)' : '#f7d7e3' }} />

                                    </Col>
                                    <Col md={{ span: 1, offset: 1 }} xs={{ span: 1, offset: 1 }}>
                                        <Image alt='sincroniza drive' src={drive} onClick={() => { this.state.open === 'drive' ? this.setState({ open: null }) : this.setState({ open: 'drive' }); this.renderCargar('drive'); }}
                                            style={{ width: '4vh', borderRadius: '3em', filter: 'grayscale(' + this.state.driveIn + ')', background: this.state.open === 'drive' ? 'rgb(222, 181, 243)' : '#f7f7e3' }} />

                                    </Col>
                                    <Col md={{ span: 1, offset: 1 }} xs={{ span: 1, offset: 1 }}>
                                        <Image alt='sincroniza calendar' src={calendar} onClick={() => { this.state.open === 'calendar' ? this.setState({ open: null }) : this.setState({ open: 'calendar' }); this.renderCargar('calendar'); }}
                                            style={{ filter: 'grayscale(' + this.state.calendarIn + ')', background: this.state.open === 'calendar' ? 'rgb(222, 181, 243)' : '#f7f7e3', width: '4vh', borderRadius: '3em' }} />

                                    </Col>
                                    <Col md={{ span: 1, offset: 1 }} xs={{ span: 1, offset: 1 }}>
                                        <Image alt='sincroniza trello' src={trelloImg} onClick={() => { this.state.open === 'trello' ? this.setState({ open: null }) : this.setState({ open: 'trello' }); this.renderCargar('trello'); }}
                                            style={{ filter: 'grayscale(' + this.state.trelloIn + ')', background: this.state.open === 'trello' ? 'rgb(222, 181, 243)' : '#f7f7e3', width: '4vh', borderRadius: '3em' }} />

                                    </Col>
                                </Row>
                                <Row className='utils_image' xs={{ span: 12 }}>
                                    <Col md={{ span: 1, offset: 2 }} xs={{ span: 1, offset: 2 }}>
                                        <Image alt='sincroniza asana' src={asana} onClick={() => { this.state.open === 'asana' ? this.setState({ open: null }) : this.setState({ open: 'asana' }); this.renderCargar('asana'); }}
                                            style={{ filter: 'grayscale(' + this.state.asanaIn + ')', background: this.state.open === 'trello' ? 'rgb(222, 181, 243)' : '#f7f7e3', width: '4vh', borderRadius: '3em' }} />

                                    </Col>
                                    <Col md={{ span: 1, offset: 1 }} xs={{ span: 1, offset: 1 }}>
                                        <Image alt='sincroniza googleSheet' src={googleSheet} onClick={() => { this.state.open === 'sheet' ? this.setState({ open: null }) : this.setState({ open: 'sheet' }); this.renderCargar('sheet'); }}
                                            style={{ filter: 'grayscale(1)', background: this.state.open === 'trello' ? 'rgb(222, 181, 243)' : '#f7f7e3', width: '4vh', borderRadius: '3em' }} />

                                    </Col>
                                    <Col md={{ span: 1, offset: 1 }} xs={{ span: 1, offset: 1 }}>
                                        <Image alt='sincroniza clickup' src={clickup} onClick={() => { this.state.open === 'clickup' ? this.setState({ open: null }) : this.setState({ open: 'clickup' }); this.renderCargar('clickup'); }}
                                            style={{ filter: 'grayscale(1)', background: this.state.open === 'trello' ? 'rgb(222, 181, 243)' : '#f7f7e3', width: '4vh', borderRadius: '3em' }} />

                                    </Col>

                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='utils_image'>

                                <Button variant="primary" style={styleButtonProfile} onClick={() => { history.push('/newworkflow'); }} inverted>
                                    <i className="material-icons md-12">military_tech</i> Crea tu propio flujo de trabajo
                            </Button>

                            </Col>
                        </Row>
                    </Col>
                    <Col md={{ span: 8 }} xs={12} className='form_height' >
                        {this.renderForm()}

                    </Col>
                    <Col>
                        <Modal show={this.state.openImagen}  >
                            <Modal.Header >
                                <Modal.Title>Agrega una nueva Imagen</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Container>
                                    <Row>
                                        <Col>
                                            <Image rounded className='chage_image_modal' src={this.state.imagenMostrar ? this.state.imagenMostrar : 'https://react.semantic-ui.com/images/avatar/large/rachel.png'}></Image>
                                        </Col>

                                        <Col>
                                            <Form>

                                                <Form.Group controlId="ControlInput21">
                                                    <Form.Label>Selecciona tu fondo</Form.Label>
                                                    <Form.Control name="comemt" placeholder='https://react.semantic-ui.com/images...'
                                                        type="text" onClick={() => { this.renderCargarImagen(this.state.imagenFondo); }}
                                                        value={this.state.imagenFondo}
                                                        onChange={(e) => { this.setState({ imagenFondo: e.target.value }); this.renderCargarImagen(e.target.value); }} />
                                                </Form.Group>
                                                <Form.Group controlId="ControlInput22">
                                                    <Form.Label>Selecciona tu perfil</Form.Label>
                                                    <Form.Control name="comemt" placeholder='https://react.semantic-ui.com/images...'
                                                        type="text" onClick={() => { this.renderCargarImagen(this.state.imagenPerfil); }}
                                                        value={this.state.imagenPerfil}
                                                        onChange={(e) => { this.setState({ imagenPerfil: e.target.value }); this.renderCargarImagen(e.target.value); }} />
                                                </Form.Group>
                                            </Form>
                                        </Col>
                                    </Row>
                                </Container>
                            </Modal.Body>
                            <Modal.Footer>

                                <Button variant="light" onClick={() => this.close()} inverted>
                                    Cancelar</Button>
                                <Button variant="primary" style={styleButtonProfile} onClick={() => { this.close(); this.renderGuardar(); }} inverted>
                                    <i className="material-icons md-12">add_comment</i>  Guardar
                            </Button>

                            </Modal.Footer>

                        </Modal>
                    </Col>
                </Row>

            </Container>


        );
    }
}
const mapStateToProps = (state) => {
    return {
        userDetail: state.mainReducer.userDetail,
        isSignedIn: state.mainReducer.isSignedIn,
        messageAsana: state.mainReducer.messageAsana,
    };
};


export default connect(mapStateToProps, { popupBot, messageAsanas })(Profile);